import images from "../../../images";

const graphicsList = [
    {
        title: "Strawberry Bunny",
        subtitle: "https://strawberry-bunny.neocities.org/",
        thumbnail: images.strawberrybunny.url,
        url: "https://strawberry-bunny.neocities.org/"
    },
     {
        title: "Graphics Hoard",
        subtitle: "https://graphics-hoard.neocities.org/",
        thumbnail: images.graphicshoard.url,
        url: "https://graphics-hoard.neocities.org/"
    },
    {
        title: "killychan",
        subtitle: "https://killychan.neocities.org/",
        thumbnail: images.killychan.url,
        url: "https://killychan.neocities.org/"
    },
    {
        title: "allyratworld",
        subtitle: "https://allyratworld.com/mat/material",
        thumbnail: images.allyratworld.url,
        url: "https://allyratworld.com/mat/material"
    },
      {
        title: "https://xixxii.neocities.org",
        subtitle: "https://xixxii.neocities.org",
        thumbnail: images.xixxii.url,
        url: "https://xixxii.neocities.org/gooftown/foryou/borders"
    },
    {
        title: "https://engrampixel.tumblr.com/",
        subtitle: "https://engrampixel.tumblr.com/",
        thumbnail: images.engrampixek.url,
        url: "https://engrampixel.tumblr.com/"
    },
    {
        title: "https://velvetmoth.neocities.org/",
        subtitle: "https://velvetmoth.neocities.org/",
        thumbnail: images.velvetmoth.url,
        url: "https://velvetmoth.neocities.org/"
    },
    {
        title: "https://pixelsafari.neocities.org",
        subtitle: "https://pixelsafari.neocities.org",
        thumbnail: images.pixelsafari.url,
        url: "https://pixelsafari.neocities.org"
    },
    {
        title: "https://rentryresource.neocities.org",
        subtitle: "https://rentryresource.neocities.org",
        thumbnail: images.rentryresource.url,
        url: "https://rentryresource.neocities.org"
    }
]

export default graphicsList;